import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import DroppableContainer from './DroppableContainer';
import SortableAssetItem from './SortableAssetItem';

/**
 * SelectedAssetsPanel - Panel displaying available assets for selection
 * Allows dragging assets to the physical connection panel
 * Supports output speed ratio input for Gearbox assets
 */
const SelectedAssetsPanel = ({
    assets,
    activeId,
    title,
    onOutputRatioChange,
    getAssetValidation
}) => {
    const { t: translate } = useTranslation();
    const displayTitle = title || translate('ABB.Powertrain.Frontend.ptToolsPowertrainWizard_AssetSelection_SelectedAssetsTitle');

    return (
        <div className='selected-assets-panel'>
            <h3 className='panel-title'>{displayTitle}</h3>
            <DroppableContainer id='selected-assets' className='assets-list'>
                <SortableContext
                    items={assets.map(asset => asset.id)}
                    strategy={verticalListSortingStrategy}
                >
                    {assets.map(asset => {
                        // Get validation status for this asset
                        const validationStatus = getAssetValidation ? getAssetValidation(asset) : null;

                        return (
                            <SortableAssetItem
                                key={asset.id}
                                asset={asset}
                                isDragging={activeId === asset.id}
                                onOutputRatioChange={onOutputRatioChange}
                                isInSelectedAssets={true}
                                validationStatus={validationStatus}
                            />
                        );
                    })}
                </SortableContext>
            </DroppableContainer>
        </div>
    );
};

SelectedAssetsPanel.propTypes = {
    assets: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        assetId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        selectedSubType: PropTypes.string,
        outputSpeedRatio: PropTypes.string
    })).isRequired,
    activeId: PropTypes.string,
    title: PropTypes.string,
    onOutputRatioChange: PropTypes.func,
    getAssetValidation: PropTypes.func
};

export default SelectedAssetsPanel;
